<script setup lang="ts">
import { useCart } from "@/composables/useCart";
import { Card as FCard, Popover as FPopover } from "frappe-ui";
import BCartFullSummary from "./cart/BCartFullSummary.vue";
import { BMicroChipGroup, BMicroChip, BButton } from "@/dokos-ui";

const cart = useCart();
</script>

<template>
  <FPopover>
    <template #target="{ togglePopover }">
      <div class="relative">
        <BButton
          variant="soft"
          leading-icon="shopping-cart"
          @click="togglePopover"
          aria-label="Panier"
        />
        <BMicroChipGroup v-if="cart?.total_qty" class="pointer-events-none">
          <BMicroChip
            class="bg-red-700 text-white font-extrabold rounded-full tabular-nums"
          >
            {{ cart.total_qty }}
          </BMicroChip>
        </BMicroChipGroup>
      </div>
    </template>
    <template #body>
      <FCard v-if="cart" title="Panier">
        <BCartFullSummary />
      </FCard>
    </template>
  </FPopover>
</template>
